import Url from 'url-parse';
export default class Redirection {
  /**
   * @type {Url}
   */
  redirectUrl = '';
  constructor(url) {
    if (url) {
      this.changeUrl(url);
    }
  }

  addParams(params) {
    if (this.redirectUrl.hash) {
      const originValue = this.redirectUrl.hash;
      if (!!~originValue.indexOf('?')) {
        this.redirectUrl.set('hash', `${originValue}&${params}`);
      } else {
        this.redirectUrl.set('hash', `${originValue}?${params}`);
      }
      return;
    }
    if (this.redirectUrl.query) {
      const originValue = this.redirectUrl.query;
      if (!!~originValue.indexOf('?')) {
        this.redirectUrl.set('query', `${originValue}&${params}`);
      } else {
        this.redirectUrl.set('query', `${originValue}?${params}`);
      }
      return;
    }
  }

  changeUrl(url) {
    this.redirectUrl = new Url(url);
  }

  setLocaleStore(url) {
    window.localStorage.setItem('amazingSeasunRedirction', url || this.redirectUrl.toString());
  }

  clearLocalStore() {
    window.localStorage.setItem('amazingSeasunRedirction', '');
  }

  getLocalStore() {
    const url = window.localStorage.getItem('amazingSeasunRedirction');
    if (url) {
      this.changeUrl(url);
    }
  }

  toString() {
    return this.redirectUrl.toString();
  }

  /*changeHref(params) {
    if (typeof params === 'string') {
    } else {
    }
  }*/
}
